import {
    takeEvery, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/AdminSettingSeminarRoom';
import { waitAuthorizedCheck } from './Auth';

function* getSettingSeminarRoom(action) {
    const endpoint = `/api/v1/settings/${action.payload}/seminar/`;
    try {
        const response = yield call(API.get, { endpoint });
        response.forEach((room, index) => {
            room.id = index;
            room.times.forEach((time, timeIndex) => {
                time.id = timeIndex;
            });
        });
        yield put(Actions.getSettingSeminarRoomReceived(response));
    } catch (error) {
        yield put(Actions.getSettingSeminarRoomReceiveFailure(yield error));
    }
}

function* updateSettingSeminarRoom(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/settings/${action.payload.eventShortName}/seminar/`;
        const response = yield call(API.put, {
            endpoint,
            body: { content: action.payload.body },
            token: credential.data.token,
        });
        yield put(Actions.updateSettingSeminarRoomReceived(response));
    } catch (error) {
        yield put(Actions.updateSettingSeminarRoomReceiveFailure(yield error));
    }
}

export default function* login() {
    yield all([
        takeEvery('GET_SETTING_SEMINAR_ROOM_REQUEST', getSettingSeminarRoom),
        takeEvery('UPDATE_SETTING_SEMINAR_ROOM_REQUEST', updateSettingSeminarRoom),
    ]);
}
